module.exports = __webpack_public_path__ + "static/media/time-up-sound.cc3f8a08.mp3";